/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import Keycloak, { KeycloakInitOptions } from "keycloak-js";
import HttpClient from '../utils/httpClient';
import { pushGTM,formatPhone } from '../utils/utils';
/**
 * Service used to manage authorization using keycloak
 */

import { setUserToken, setUserLoggedIn, setUserInfo, setKey, isUserLoggedIn, getSessionStorageCustom, getKey } from "../utils/storageManager";
import { getLocalStorage, setLocalStorage } from "../utils/cacheHandler";
import { setCookie } from "../utils/cookieManager";
import { Logger } from "../utils/logger";



declare global {
    interface Window {
        AUTH_CONFIG: any;
    }
}

const config: any = window.AUTH_CONFIG;
const _kc = new Keycloak(config);


const doLogin = () => _kc.login;

const doLogout = (redirectUri: any) => _kc.logout(redirectUri);
const getToken = () => _kc.token;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback: any) =>
    _kc.updateToken(5)
        .then(successCallback)
        .catch(doLogin);

const getUsername = () => _kc.tokenParsed?.preferred_username;

const getName = () => _kc.tokenParsed?.name;


const getInfo = () => {
    return _kc;
}


const hasRole = (roles: any) => roles.some((role: any) => _kc.hasRealmRole(role));


/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = async (onAuthenticatedCallback: any):Promise<typeof _kc> => {
    return new Promise((resolve, reject) =>{
    const accessToken = getLocalStorage('keycloack-accesstoken')?.replace(/^"|"$/g, '');
    const refreshToken = getLocalStorage('keycloack-refreshToken')?.replace(/^"|"$/g, '');
        const initOptions: KeycloakInitOptions = {
        onLoad: accessToken?'check-sso':'login-required',
        pkceMethod: 'S256',
        redirectUri: getRedirectPath(),
        token: accessToken,
        refreshToken: refreshToken,
        checkLoginIframe: false
    };
    return _kc.init(initOptions)
        .then(async (authenticated) => {
            /**
             * If keycloak's current session id is equal to previous one
             * it means the user opens the app in the new tab or refresh the current tab
             * so we need to logout user in that case
             */
            // const sessionId = getCookie('sessionId');
            // if(sessionId === _kc.sessionId) {
            //     _kc.logout();
            //     return;
            // }
            setCookie('sessionId', _kc.sessionId);
            if (!authenticated) {
                initOptions.onLoad='login-required';
                initOptions.token=undefined;
                initOptions.refreshToken=undefined;
                await _kc.init({...initOptions})
                console.log("User is not authenticated..!");
            }


            /**
             * setting access key token to call subsequent api calls
             */

            HttpClient.setToken(_kc.token || '');

            /**
             * refressing access token in rugular intervals
             */
            setInterval(async () => {
                if (_kc.isTokenExpired(50)) {
                    await _kc.updateToken(50);
                    HttpClient.setToken(_kc.token || '');
                    setUserToken(_kc.token || '')
                }
            }, 30000);
            setUserToken(_kc.token || '');
            
            /* This code handles check-sso login page refresh behavior.
            On browser refresh after check-sso login, redirect the user to '/postauth'
            to ensure the KeyCloakPostLogin screen is properly processed.
            Uses sessionStorage to prevent repeated redirects and avoids infinite loops.
            */
            if (initOptions.onLoad === 'check-sso') {
                const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
                const navType = navEntries.length > 0
                    ? navEntries[0].type
                    : (performance as any).navigation?.type === 1
                        ? 'reload'
                        : 'navigate'; // fallback value
                const isRefresh = navType === 'reload';
                const hasRedirected = sessionStorage.getItem('hasRedirected');
                const currentPath = window.location.pathname;
                if (authenticated && isRefresh && !hasRedirected && currentPath !== '/postauth') {
                    sessionStorage.setItem('hasRedirected', 'true');
                    window.location.href = '/postauth';
                    return;
                }
                // Optional: clean redirect flag if you're on /postauth
                if (currentPath === '/postauth') {
                    sessionStorage.removeItem('hasRedirected');
                }
            }
            const loggedInStatus = isUserLoggedIn();
            //user already logged in
            if (loggedInStatus) {
                onAuthenticatedCallback();
                resolve(_kc); 
            }
            else {
                await __setSession(() => {
                    onAuthenticatedCallback();
                    resolve(_kc); 
                });
            }




        })
        .catch((err) => {
            Logger.error("authservice.ts :: ",err);
            reject(err);
          });
    });
}
/**
 * method to get redirect path 
 */
const getRedirectPath = () => {
    const protocol = window.location.protocol;       
    const host = window.location.host;
    const redirectUrl   = protocol + '//' + host;
    let isUserRefreshed = getSessionStorageCustom("isUserRefreshed")
    const MXMSsoLogin = JSON.parse(getLocalStorage('MXMSsoLogin'))
    const loggedInStatus = isUserLoggedIn();
    const userId = getKey('id');
    let proxyToken :any;

    if(window?.location?.pathname.includes('sso/')){
        proxyToken=window?.location?.pathname?.split('/')[2];
    }
    else{
    proxyToken= getLocalStorage('proxyToken') && JSON.parse(getLocalStorage('proxyToken'));
    }
    const proxylogin: any = window?.location?.pathname?.includes('/proxylogin');

    let retUrl: any = (!proxylogin && !proxyToken) && redirectUrl + '/postauth'; //default for user with no session

    /**
    * Checks if the user ID is missing and whether the user is already logged in.  
    * If both conditions are met, it indicates that the UI was opened in a new tab,  
    * and the user should be marked as refreshed.
    */
    if (!userId && loggedInStatus) {
        isUserRefreshed = true;
    }

    if(window.location.pathname==='/logout'){
        retUrl = undefined
    }
    else if (isUserRefreshed && loggedInStatus && !proxyToken && !MXMSsoLogin) {
        retUrl = redirectUrl+'/postauth'
    }
    else if (isUserRefreshed && loggedInStatus && JSON.parse(getLocalStorage('isProxyLogin') && !MXMSsoLogin)) {
        retUrl = redirectUrl+'/proxylogin/' + proxyToken
    }
    else if (isUserRefreshed && loggedInStatus && MXMSsoLogin) {
        retUrl = proxyToken ? redirectUrl + '/sso/' + proxyToken : redirectUrl + '/sso'
    }
   
    return retUrl
}
/**
 * Method to set user session variables
 */
const __setSession = async (cb: any) => {
    const user = _kc.idTokenParsed;
    setUserInfo(user?.given_name);
    setKey("isUserDetailsAvailable", 'FALSE');
    
    const gtmData = {
        event: "getCustomerInfo",
        "userAuthName": user?.given_name,
        "userId": user?.email,
        "userName": user?.given_name
    }

    pushGTM(gtmData)
    setUserLoggedIn();
    setKeys(user)
    return cb(true);
}

function setKeys(user: any){
    setKey("email", user?.email);
    setKey("firstName", user?.given_name);
    setKey("lastName", user?.family_name);
    if (_kc.tokenParsed?.MXM_USERID) {
        setLocalStorage('mxmUser',true)
    }
    setLocalStorage("referrer", document?.referrer);
    //phone number from keycloak including country code
    const kMob = user?.mobileNumber

    kMob  && setKey("phone", formatPhone(kMob.slice(-10)));

    // setKey("countryCode", "91");
    setKey("email", user?.email);
    setKey("firstName", user?.given_name);
}

const AuthService = {
    initKeycloak,
    doLogin,
    doLogout,
    isLoggedIn,
    getToken,
    updateToken,
    getUsername,
    hasRole,
    getName,
    getInfo
};

export default AuthService;